import GenericTile from "./GenericTile";

export default GenericTile;
